import {Component, OnInit, Input, ChangeDetectorRef} from '@angular/core';
import {NavController, ModalController} from '@ionic/angular';
import {APIService} from 'src/app/API.service';
import {Router} from '@angular/router';
import {EditContractPage} from '../../../edit-contract/edit-contract.page';
import {SessionService} from '../../../services/session.service';
import {DataStore} from '@aws-amplify/datastore';
import {Contract, PermissionType, User} from '../../../../models';
import {Roles, Percentages} from '../../../enums/enums';
import {Predicates, SortDirection} from 'aws-amplify';

@Component({
    selector: 'app-client-contracts',
    templateUrl: './client-contracts.component.html',
    styleUrls: ['./client-contracts.component.scss'],
})
export class ClientContractsComponent implements OnInit {
    @Input() owner: any;
    @Input() type: string = 'contract';
    private filters: any;
    filteredContractList: Contract[] = [];

    contractsList: Contract[] = [];
    cssClass: string;
    p;
    client = null;
    clients = [];
    now = Date.now();
    permession = null;
    contractsStream = null;

    constructor(
        public navController: NavController,
        public apiService: APIService,
        public sessionService: SessionService,
        public router: Router,
        public modalController: ModalController,
        private ref: ChangeDetectorRef,
    ) {
    }

    async ngOnInit() {

        this.p = Percentages;
        await this.refreshContractList();
    }

    async ionViewDidEnter() {

        this.p = Percentages;
        await this.refreshContractList();
    }


    private async refreshContractList() {

        this.contractsList = [];
        // const currentUser = this.sessionService.getCurrentUser();
        // this.contractsList =  await (await DataStore.query(Contract)).filter(c => { return c.userID == this.sessionService.user?.id });
        const contracts = await DataStore.query(Contract, Predicates.ALL, {sort: condition => condition.startDate(SortDirection.ASCENDING)},

            //   condition => condition.or(y => condition.userID('eq', this.owner.id)),
        );

        for (let t of contracts) {
            this.clients[t.id] = await DataStore.query(User, t.clientId);
        }
        let filter = (c: Contract) => {
            return c.commercial?.id == this.owner?.id || c.clientId == this.owner.id;
        };

        if (this.owner?.permessions == 'CLIENT' || this.type == 'investment') {
            filter = c => {
                return c.clientId == this.owner.id;
            };
            this.client = this.owner;
        }


        this.contractsList = contracts.filter(filter);
        if (this.owner?.permessions == PermissionType.CLIENT) {
            this.permession = 'client';
        }

        this.filteredContractList = this.contractsList;
        console.log("pemission:" + this.permession);
         this.contractsStream = DataStore.observeQuery(Contract, Predicates.ALL, {sort: condition => condition.startDate(SortDirection.ASCENDING)},).subscribe(msg => {

            this.contractsList = this.filteredContractList = msg.items.filter(filter);
        })
        this.ref.detectChanges();

    }


// @todo
    openContract(contractId: string) {
        this.cssClass = '';
        this.router.navigate(['/contract', contractId]);
    }

    async editContract(contractId: string) {
        await this.openEditContractModal(contractId);
    }

    async addContract() {
        await this.openEditContractModal(null);
    }

    private async openEditContractModal(contractId: any) {
        const modal = await this.modalController.create({
            component: EditContractPage,
            componentProps: {contractId: contractId, client: this.owner},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(async data => {
            setTimeout(async () => {
                await this.refreshContractList();
                this.ref.detectChanges();
            }, 1000);

        });
    }

    async deleteContract(contractId: string) {
        this.cssClass = '';

        if (confirm('Do you really want to delete this Contract')) {
            await DataStore.delete(Contract, contractId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshContractList();
            }, 1000);
        }
    }

    active(id: string) {

    }

    public trackItem(index: number, item: any) {
        return item.id;
    }


    async filterContracts(filters) {
        this.filters = filters;


        if (filters['name'].trim().length == 0) {
            this.filteredContractList = this.contractsList;
        }

        this.filteredContractList = this.contractsList.filter(u => {
            let matcheNames = '.+';
            let matcheStatus = true;

            if (filters['name']?.trim().length != 0)
                matcheNames = filters['name'];
            else return true;
            const reName = new RegExp(matcheNames?.toLocaleLowerCase(), 'gi');

            // if (filters['status'] != 'Tutti') {
            //     matcheStatus = u.status == filters['status']
            // }

            // make sure we don't take into account users with no name
            // if(!u.userContractsAddedId || !u.commercial.lastname || !u.status) return false;

            // const bonusUser = await (await DataStore.query(User, user => user.id("eq", u.userID)))[0];
            let x = `${u.commercial?.name?.toLocaleLowerCase()} ${u.commercial?.lastname?.toLocaleLowerCase()}`.match(reName);


            return x;
            // return `${bonusUser.name} ${bonusUser.lastname}`.match(reName) && matcheStatus;
        });


        this.filteredContractList = this.filteredContractList.sort((a, b) => {
            if (filters.filterBy == 'amount')
                if (filters.sort == SortDirection.ASCENDING) {
                    return a.amount - b.amount;
                } else {
                    return b.amount - a.amount;
                }
            if (filters.sort == SortDirection.ASCENDING) {
                if (filters.filterBy == '_lastChangedAt')
                    return a[filters.filterBy] - b[filters.filterBy];
                return a[filters.filterBy]?.toString().localeCompare(b[filters.filterBy]?.toString());
            } else {
                if (filters.filterBy == '_lastChangedAt')
                    return b[filters.filterBy] - a[filters.filterBy];
                return b[filters.filterBy]?.toString().localeCompare(a[filters.filterBy]?.toString());
            }
        });

    }

}
